import styled from 'styled-components';

export default styled.div`
  height: 1px;
  width: 100%;
  margin: 25px auto;
  background-color: ${process.env.REACT_APP_COLOR_LIGHT_GRAY};
`;
